import React from 'react';
import Col from './col';
var Row = function (props) {
    var row = props.row, index = props.index, layout = props.layout, colon = props.colon, bordered = props.bordered, prefixCls = props.prefixCls;
    var renderCols = function (renderType) {
        return row.map(function (item, idx) { return (React.createElement(Col, { key: idx, index: idx, prefixCls: prefixCls, item: item, bordered: bordered, colon: colon, type: renderType })); });
    };
    if (layout === 'vertical') {
        return (React.createElement(React.Fragment, null,
            React.createElement("tr", { className: prefixCls + "__row", key: "label-" + index }, renderCols('label')),
            React.createElement("tr", { className: prefixCls + "__row", key: "content-" + index }, renderCols('content'))));
    }
    return (React.createElement("tr", { className: prefixCls + "__row", key: index }, renderCols('item')));
};
export default Row;
//# sourceMappingURL=row.js.map